export default __webpack_public_path__ + "static/media/Main-Logo-04.8d25d822.png";